export const uppercaseRegexp: RegExp = /[A-Z]/;
